"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getThemeContent = void 0;
var utils_1 = require("../utils");
var generateTyposCSS_1 = require("./generateTyposCSS");
var getThemeData_1 = require("./getThemeData");
var getThemeContent = function (themeTokens, typoTokens, mixin, withDesignPrefix, withKebabCase) {
    var _a;
    if (mixin === void 0) { mixin = {}; }
    var result = {};
    var groupedThemes = Object.entries(themeTokens).reduce(function (acc, _a) {
        var _b, _c;
        var theme = _a[0], themeItem = _a[1];
        var _d = theme.split('__'), themeName = _d[0], themeType = _d[1];
        return __assign(__assign({}, acc), (_b = {}, _b[themeName] = __assign(__assign({}, acc[themeName]), (_c = {}, _c[themeType] = themeItem, _c)), _b));
    }, {});
    for (var _i = 0, _b = Object.entries(groupedThemes); _i < _b.length; _i++) {
        var _c = _b[_i], themeName = _c[0], _d = _c[1], dark = _d.dark, light = _d.light;
        var darkColors = (0, utils_1.attachToRoot)((0, getThemeData_1.getThemeData)(dark, mixin, withKebabCase));
        var lightColors = (0, utils_1.attachToRoot)((0, getThemeData_1.getThemeData)(light, mixin, withKebabCase));
        var typo = (0, generateTyposCSS_1.getTypoCSS)(typoTokens, withDesignPrefix);
        result = __assign(__assign({}, result), (_a = {}, _a[themeName] = {
            dark: darkColors,
            light: lightColors,
            typo: typo,
        }, _a));
    }
    return result;
};
exports.getThemeContent = getThemeContent;
//# sourceMappingURL=getThemeContent.js.map